import { Link } from "@/components/common/Link";
import { Pill, Network, Activity } from "lucide-react";
const relatedApps = [{
  title: "מטפל סיעודי עכשיו",
  url: "/NursingCareNowPage",
  icon: Activity
}, {
  title: "הבלוג המקצועי",
  url: "/ProfessionalBlogPage",
  icon: Network
}, {
  title: "צור קשר מיידי",
  url: "/ContactPage",
  icon: Pill
}];
export default function RelatedApps() {
  return <section data-section-id="258216" id="שירותים-סיעודיים" className="py-12 md:py-16 bg-background text-foreground">
      <div className="container mx-auto px-4">
        <h2 className="text-2xl md:text-4xl font-default font-bold text-primary mb-6 md:mb-8">
          שירותים סיעודיים משלימים
        </h2>
        
        <div className="grid grid-cols-2 sm:grid-cols-3 md:grid-cols-4 lg:grid-cols-6 gap-4">
          {relatedApps.map((app, i) => {
          const Icon = app.icon;
          return <Link key={i} to={app.url} data-index={i} className="group block">
                <div className="bg-card text-card-foreground border border-border aspect-square flex flex-col items-center justify-center p-4 rounded-lg transition-all duration-300 hover:-translate-y-1 hover:shadow-lg hover:border-primary/20">
                  <Icon className="w-12 h-12 md:w-16 md:h-16 mb-3 stroke-[1.5] text-secondary" />
                  <h3 className="text-sm md:text-lg font-default font-semibold text-center leading-tight">
                    {app.title}
                  </h3>
                </div>
              </Link>;
        })}
        </div>
      </div>
    </section>;
}